import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import classNames from 'clsx';
import { AppSections, AppQueryParams } from '../../constants';
import Icons from '../../constants/Icons';
import { useEventTracker } from '../hooks';

const ProductItem = ({ data: product, sectionId, isWeb, isLiveRoomsSection, token }) => {
  const { t } = useTranslation();

  const trackEvent = useEventTracker();

  const [expiryCountdown, setExpiryCountdown] = useState('');

  const navigate = useNavigate();

  const handleProductItemClick = () => {
    trackEvent('product_details_screen', {
      product_id: product.id,
      product_name: product.name,
    });

    window.trackEvent('button_view_clicked', {
      source: 'shop',
      product_id: product.id,
      is_guest: !token,
    });

    const queryString = new URLSearchParams();

    if (token) {
      queryString.set('userToken', token);
    }

    if (isWeb) {
      queryString.set('source', 'web');
    }

    if (isLiveRoomsSection) {
      queryString.set(AppQueryParams.AppSection, AppSections.LiveRoom);

      if (sectionId) {
        sessionStorage.setItem(`${AppSections.LiveRoom}-section`, `${sectionId}`);
      }
    }

    navigate(
      `/shop/products/${product.id}${queryString.size > 0 ? '?' + queryString.toString() : ''}`,
      isLiveRoomsSection
        ? {
            state: {
              from: window.location.href,
              isBackAllowed: true,
            },
          }
        : undefined,
    );
  };

  const addLeadingZeros = (value) => {
    value = String(value);
    while (value.length < 2) {
      value = '0' + value;
    }
    return value;
  };

  useEffect(() => {
    if (product.expirationDate) {
      setInterval(() => {
        const then = moment(product.expirationDate, 'YYYY-MM-DD hh:mm:ss');
        const now = moment();
        const countdown = then.diff(now);
        const tempTime = moment.duration(countdown);
        const days = tempTime.days();
        const hours = addLeadingZeros(tempTime.hours());
        const minutes = addLeadingZeros(tempTime.minutes());
        const seconds = addLeadingZeros(tempTime.seconds());

        setExpiryCountdown(
          days && days > 0
            ? `${days} ${t(days > 1 ? 'days_left' : 'day_left')}`
            : `${hours}:${minutes}:${seconds}`,
        );
      }, 1000);
    }
  }, [product.expirationDate]);

  const productItemClassName = classNames('product-item-div', {
    'product-item-div-lg': isWeb,
    'product-item-div-mobile': isWeb,
  });

  return (
    <div className={productItemClassName} onClick={handleProductItemClick}>
      <div className="product-item-shop-header">
        {product.shop.backgroundImageURL && !product.shop.backgroundImageURL.includes('plus') && (
          <div className="shop-img-in-product-container">
            <img className="shop-img-in-product" alt="" src={product.shop.backgroundImageURL} />{' '}
          </div>
        )}
        <div className="product-shop-div">
          <p className="shop-name-in-product">{product.shop.title}</p>
          <p className="merch">{t('merch')}</p>
        </div>
      </div>
      <div className="product-img-div">
        {expiryCountdown && <span className="product-expiration">{expiryCountdown}</span>}
        <img className="product-img" alt="" src={product.backgroundImageURL} />
      </div>
      <div className="product-name-div">
        <p className="product-name">{product.name}</p>
      </div>
      <div className="two-items-flex-div mb-1 px-1">
        <p className="product-cost">
          {product.price && !isWeb ? (
            <>
              <img src={Icons.diamond} className="diamond-img" alt="diamond img" />
              {product.price}
            </>
          ) : (
            <>
              <img src={Icons.dollar} className="dollar-img" alt="dollar img" />
              <span>{product.priceMoney.split('.')[0]}</span>
            </>
          )}
        </p>
        <p className="amount-left-text">
          <img src={Icons.fire} className="fire-img" alt="fire img" />
          <span>
            {product.totalStock} {t('left')}
          </span>
        </p>
      </div>
      <button className="shop-btn full dark">{t('view')}</button>
    </div>
  );
};

export default ProductItem;
